import {useEffect, useState} from "react";
import '../index.css'
import NorthIcon from '@mui/icons-material/North';

export default function ScrollTopButton () {

        const [isVisible, setIsVisible] = useState(false);

        const toggleVisibility = () => {
            if (window.pageYOffset > 800) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }

        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }

        useEffect(() => {
            window.addEventListener('scroll', toggleVisibility);
            return () => window.removeEventListener('scroll', toggleVisibility);
        }, [])

    return (
        <div className="scroll-to-top-container" style={{display: isVisible ? 'block' : 'none'}}>
            <button onClick={scrollToTop} className="scroll-to-top-button">
                {/*Top*/}
                <NorthIcon />
            </button>
        </div>
    )

}